const mutations = {
  saveToken(state, data) {
    state.tokenInfo = data;
  },
  setShowRealPrice(state, data) {
    state.tokenInfo.show_real_price = data;
  },
  editEwmData(state, data) {
    state.ewmData = data;
  },
  editUserInfo(state, data) {
    state.userInfo = data;
  },
  editCan_balance_pay(state, can_balance_pay) {
    state.can_balance_pay = can_balance_pay;
  },
  saveOrderList(state, data) {
    state.orderList = data;
  },
  saveTubesList(state, data) {
    state.tubesList = data;
  },
  savePatientInfo(state, data) {
    state.patientInfo = data;
  },
  saveEditTubes(state, data) {
    state.editTubes = data;
    state.editPatientInfo = {}
  },
  saveEditPatientInfo(state, data) {
    state.editPatientInfo = data;
    state.editTubes = [];
  },
  addCartItem(state, item) {
    if (state.cartItems.filter(cartItem => cartItem.id === item.id).length === 0) {
      state.cartItems.push(item)
    }
  },
  clearCartItem(state) {
    state.cartItems = []
  },
  removeCartItem(state, item) {
    let index = state.cartItems.findIndex(cartItem => cartItem.id === item.id)
    state.cartItems.splice(index, 1)
  },
  remoteCartItem(state, index) {
    state.cartItems.splice(index, 1)
  }
};
export default mutations;
